import { useRef, useEffect, useState, useContext } from "react";
import { useMediaQuery, useTheme } from "@mui/material";

import { pink, babyBlue } from "../config";
import "../keyframes.css";
import { TestStoreContext } from "@natklok/contexts/testStoreContext";

const generateBlobInfo = (isQuestionBlobs, isResultBlobs) => {
  /*let availablePositions = [
    { x: "15%", y: "20%" },
    { x: "10%", y: "40%" },
    { x: "15%", y: "60%" },
    { x: "85%", y: "20%" },
    { x: "90%", y: "40%" },
    { x: "85%", y: "65%" },
  ];*/
  let standardblobInfo = [
    { x: "15%", y: "20%", diam: 70, opacity: 1 },
    { x: "15%", y: "60%", diam: 150, opacity: 1 },
    { x: "85%", y: "40%", diam: 100, opacity: 1 },
  ];
  let questionblobInfo = [
    { x: "15%", y: "20%", diam: 70, opacity: 0.6 },
    { x: "10%", y: "40%", diam: 150, opacity: 0.6 },
    { x: "85%", y: "40%", diam: 100, opacity: 0.6 },
    { x: "80%", y: "70%", diam: 50, opacity: 0.6 },
  ];
  let resultBlobInfo = [
    { x: "20%", y: "70%", diam: 70, opacity: 1 },
    { x: "10%", y: "40%", diam: 150, opacity: 0.6 },
    { x: "85%", y: "26%", diam: 60, opacity: 0.6 },
    { x: "80%", y: "60%", diam: 120, opacity: 1 },
  ];
  if (isQuestionBlobs) {
    return questionblobInfo;
  } else if (isResultBlobs) {
    return resultBlobInfo;
  } else {
    return standardblobInfo;
  }
};

const BackgroundOrbs = ({
  hideWhenSmall = false,
  questionBlobs = false,
  resultBlobs = false,
  style = {},
}) => {
  const bgdRef = useRef(null);
  const [generatedOnce, setGeneratedOnce] = useState(false);
  const [blobInfo, setBlobInfo] = useState([]);
  const theme = useTheme();
  const { minimized } = useContext(TestStoreContext);
  const isSmallDeviceOrBigger = useMediaQuery(theme.breakpoints.up("sm"));
  const isMediumOrSmallerDevice = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    // Seed makes it possible for us to change the constalation of blobs
    if (generatedOnce === false) {
      setGeneratedOnce(true);
      setBlobInfo(generateBlobInfo(questionBlobs, resultBlobs));
    }
  }, [bgdRef, generatedOnce, questionBlobs, resultBlobs]);

  if (isMediumOrSmallerDevice && hideWhenSmall === true) {
    return null;
  } else {
    return (
      <div
        id="orbs"
        style={{
          pointerEvents: "none",
          top: 0,
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          position: "absolute",
          width: "100%",
          height: "90vh",
          marginTop: isSmallDeviceOrBigger && !minimized ? "10vh" : 0,
          overflow: "hidden",
          ...style,
        }}
      >
        {blobInfo.map((info, i) => {
          return <Blob info={info} i={i} key={i} isQuestionBlobs={questionBlobs} />;
        })}
      </div>
    );
  }
};

const Blob = ({ info, i, isQuestionBlobs }) => {
  let color = i % 2 === 0 ? pink[500] : babyBlue[300];
  let highlight = i % 2 === 0 ? "#EC90C0" : "#BCEEFF";
  let shade = i % 2 === 0 ? "#BA1369" : "#0E9DCE";
  let yPos = "calc(" + info.y + " - " + info.diam / 2 + "px)";
  let xPos = "calc(" + info.x + " - " + info.diam / 2 + "px)";
  let background = `radial-gradient(61.34% 61.34% at 66.27% 38.66%, ${highlight} 0%, ${color} 50.15%, ${shade} 100%)`;

  return (
    <div
      style={{
        width: info.diam,
        height: info.diam,
        position: "absolute",
        top: yPos,
        left: xPos,
        background: background,
        borderRadius: "100%",
        zIndex: -10,
        animation: "blobsExpand 8s infinite alternate",
        animationDelay: i * 2 + "s",
        transition: "0.8s cubic-bezier(.52,.08,.58,.93)",
        opacity: info.opacity,
      }}
    />
  );
};

export default BackgroundOrbs;
